<template>
  <div>
    <title-header
      title="Double Maddox Rod Torsion Assessment"
      subtitle="Assess and interpret torsion using double Maddox rods."
    />

    <slot></slot>

    <div class="maddoxContainer ma-6" :style="maddoxContainerStyle">
      <maddox
        v-for="eye in ['od', 'os']"
        :key="eye"
        class="maddox_lens"
        :size="maddoxSize"
        :label="eye === 'od' ? 'Right Eye' : 'Left Eye'"
        :color="eye === 'od' ? 'red' : 'white'"
        :style="`left: ${eye === 'od' ? 0 : maddoxSize * 1.3}px`"
        @valChange="rotation[eye] = $event"
      >
        {{ getMagnitudeString(torsionMagnitude[eye]) }}
        <span v-html="torsionDirection[eye]"></span>
      </maddox>
    </div>

    <simple-popover
      title="Double Maddox Rod Test: About, Setup, and Interpretation"
    >
      <template #activator>
        <div class="linkLike ml-4">
          Double Maddox Rod Instructions and Interpretation
          <v-icon x-small color="primary" class="ml-1">
            mdi-dock-window
          </v-icon>
        </div>
      </template>
      <template #content>
        <page articleSlug="maddox-rod-setup" :showHeader="false"></page>
      </template>
    </simple-popover>

    <page articleSlug="maddox-rod-discussion" :showHeader="false"></page>
  </div>
</template>

<script>
import Maddox from "./Maddox.vue";
import Page from "@/components/pagesStuff/Page";
import SimplePopover from "../universalStuff/SimplePopover.vue";
import TitleHeader from "../universalStuff/TitleHeader.vue";

export default {
  name: "Cyclotorsion",
  components: {
    Maddox,
    Page,
    SimplePopover,
    TitleHeader,
  },
  data: function () {
    return {
      rotation: {
        od: 90,
        os: 90,
      },
      rods: {
        os: 0,
      },
    };
  },
  methods: {
    getMagnitudeString(val) {
      let str = "No";
      if (val !== 0) str = Math.abs(val) + "° ";
      return str;
    },
  },
  computed: {
    maddoxSize: function () {
      return this.$vuetify.breakpoint.smAndUp ? 200 : 150;
    },
    maddoxContainerStyle: function () {
      return {
        width: `${this.maddoxSize * 3}px`,
        height: `${this.maddoxSize * 1.2}px`,
      };
    },
    torsionMagnitude: function () {
      let rtn = { od: 0, os: 0 };
      rtn.od = this.rotation.od - 90;
      rtn.os = this.rotation.os - 90;
      return rtn;
    },

    torsionDirection: function () {
      let rtn = { od: "torsion", os: "torsion" };
      if (this.torsionMagnitude.od > 0) rtn.od = "<b>Ex</b>torsion";
      if (this.torsionMagnitude.od < 0) rtn.od = "<b>In</b>torsion";
      if (this.torsionMagnitude.os < 0) rtn.os = "<b>Ex</b>torsion";
      if (this.torsionMagnitude.os > 0) rtn.os = "<b>In</b>torsion";
      return rtn;
    },
  },
};
</script>

<style scoped>
.maddoxContainer {
  position: relative;
  padding: 0;
  max-width: 95%;
  /* background-color: pink; */
}
.maddox_lens {
  position: absolute;
}
</style>
